export default {
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_Ims9eoSmR',
    APP_CLIENT_ID: '5abn79nktgltlehsc1isrbq5vg',
    IDENTITY_POOL_ID: 'us-east-1:d584231d-134c-43e2-b110-16050d787ba0'
  }
}